export default __webpack_public_path__ + "static/media/3132.f2eedd4f.jpg";